import type { ReactNode } from 'react';
import styles from './FieldShell.module.css';

interface FieldShellProps {
  children: ReactNode;
  error?: boolean;
}

export function FieldShell({ children, error = false }: FieldShellProps) {
  return (
    <div className={`${styles.fieldShell} ${error ? styles.fieldShellError : ''}`}>
      {children}
    </div>
  );
}

export default FieldShell;
